import React from 'react';

import { Typography } from '@/shared/components/atoms';

import HeaderIcon from '~/images/shared/task-square.svg';
interface IProps {
  // id: number;
  name: string;
  icon?: React.ReactNode;
}
const CollapseHeader = ({ name, icon }: IProps) => {
  // const { t } = useTranslation('common');
  return (
    <div className='flex w-full items-center justify-between'>
      <div className='flex items-center gap-16'>
        <div className='text-primary-default'>
          {icon ?? <HeaderIcon width='24' height='24' />}
        </div>
        <Typography variant='subtitle1' weight='bold'>
          {name}
        </Typography>
      </div>

      {/* 3 dot */}
      <div></div>
    </div>
  );
};
export default CollapseHeader;
